import { Component, inject, Input } from '@angular/core';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../../utility';
import { ApiService } from '../../api.service';
import { Outcome } from '../../outcome/outcome.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { WizardComponent } from '../quick-action/wizard/wizard.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '../../../environments/environment';
import { IsPlanningPhasePipe } from '../../work-package/pipes/is-planning-phase.pipe';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-backlog',
  templateUrl: './backlog.component.html',
  styleUrl: './backlog.component.css',
})
export class BacklogComponent {
  env = environment;
  @Input() userData: any;
  @Input() backlogData: any;
  @Input() outcomeData: any;
  ref: DynamicDialogRef | undefined;
  private roleSubscription: Subscription;
  private outcomeService = inject(Outcome);
  private apiService = inject(ApiService);
  private messageService = inject(MessageService);
  public dialogService = inject(DialogService);
  public toastService = inject(ToastService);

  constructor(private isPlanning: IsPlanningPhasePipe) {}

  ngOnInit(): void {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {});
  }

  transformBacklog(cat: any, backlogId: string) {
    const data = {
      backlog_id: backlogId,
      quarterly_outcomes: [],
    };
    this.outcomeService.transformBacklog(data, cat).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          if (parsedData.error) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Warn',
              detail: parsedData.message,
            });
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: parsedData.message,
            });
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  clickTransformBacklog(backlogId: any) {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.transformBacklog(data, backlogId);
    });
  }

  getLabel(status: number): string {
    switch (status) {
      case 1:
        return 'Not Started'; // Custom label for status 1
      case 2:
        return 'Ongoing'; // Custom label for status 2
      case 3:
        return 'Completed'; // Custom label for status 3
      case 4:
        return 'Delayed'; // Custom label for status 4
      case 5:
        return 'Terminated'; // Custom label for status 5
      default:
        return ''; // Default label if status is not 1, 2, or 3
    }
  }

  openWizard() {
    this.ref = this.dialogService.open(WizardComponent, {
      width: '90%',
      contentStyle: { 'max-height': '90vh', overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        backlogData: this.backlogData,
        step: 1,
      },
    });

    this.ref.onClose.subscribe(() => {
      console.log('Wizard dialog closed');
  });
  }

  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe(); // Clean up subscription when component is destroyed
    }
  }
}
